<template>
    <div class="container has-text-left margin_top_1rem">
        <b-field label="Source Device">
            <b-select v-model="deviceId">
                <option :value="0">choose device...</option>
                <option v-for="device in devices" :key="device['id']" :value="device['id']">{{device['name']}}</option>
            </b-select>
        </b-field>
        <b-field label="Source Topic" v-show="deviceId > 0">
            <b-select v-model="deviceTopicId">
                <option :value="0">choose topic...</option>
                <option
                        v-for="deviceTopic in deviceTopicsByDevice"
                        v-bind:key="deviceTopic['id']"
                        :value="deviceTopic['id']"
                >{{deviceTopic['topic']}}
                </option>
            </b-select>
        </b-field>
        <b-field :label="'Action to perform on object: ' + actionName" v-show="validFields()"></b-field>
        <div class="buttons">
            <b-button type="is-danger-outlined" @click="handleClickBack">Back</b-button>
            <b-button type="is-success" :disabled="!validFields()" @click="handleAdd">Add</b-button>
        </div>
    </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import BField from "buefy/src/components/field/Field";
  import BSelect from "buefy/src/components/select/Select";

  export default {
    components: {
      BSelect,
      BField
    },
    name: "add-prop-rule",
    props: ['object', 'handleBack'],
    data() {
      return {
        deviceId: 0,
        deviceTopicId: 0
      };
    },
    computed: {
      ...mapGetters('devices', ['devices', 'deviceTopics']),
      deviceTopicsByDevice() {
        return this.deviceTopics.filter(item => {
          return parseInt(item['device_id']) === parseInt(this.deviceId);
        });
      },
      actionTypeId() {
        return this.object && this.object['actionTypes'] && this.object['actionTypes'][0] ? this.object['actionTypes'][0]['id'] : 0;
      },
      actionName() {
        return this.object && this.object['actionTypes'] && this.object['actionTypes'][0] ? this.object['actionTypes'][0]['name'] : '';
      }
    },
    methods: {
      ...mapActions('objects', ['addPropRule']),
      resetFields() {
        this.deviceTopicId = 0;
        this.deviceId = 0;
      },
      handleClickBack() {
        this.resetFields();
        if (typeof this.handleBack === 'function') {
          this.handleBack();
        }
      },
      validFields() {
        if (this.deviceId < 1) {
          return false;
        }
        if (this.deviceTopicId < 1) {
          return false;
        }

        return true;
      },
      handleAdd() {
        this.addPropRule({
          id: parseInt(this.object.id),
          deviceId: parseInt(this.deviceId),
          deviceTopicId: parseInt(this.deviceTopicId),
          combineFunction: 'average',
          adjustmentFunction: '',
          actionTypeId: parseInt(this.actionTypeId)
        });
        this.handleClickBack();
      }
    },
    mounted() {
    }
  }
</script>

<style scoped>
    .margin_top_1rem {
        margin-top: 1rem;
    }
</style>